import React from 'react';
const IconActionDownload = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 13.27V10.66L13 14.86V5H11V14.86L6 10.66V13.27L12 18.27L18 13.27ZM3 20V22H21V20H3Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionDownload;